import { Component, input } from '@angular/core';

@Component({
    selector: 'app-divider',
    template: `
    @if (!isOrizontalDivider()) {
        <div class="border-l-2 border-solid min-h-3.5 {{height()}} m-0 {{borderColor()}}"></div>
    } @else {
        <hr class="border border-t border-solid min-w-full {{borderColor()}} {{width()}}">
    }
    `
})
export class Divider {
    isOrizontalDivider = input<boolean>(false);
    borderColor = input<string>('border-text-hover');
    height = input<string>('');
    width = input<string>('');
}
